import React from "react"
import {
  CalendarEventDataFragment,
  EventRegistration,
} from "../../../../../api/backend/backend-api"
import Typography from "../../../../../ui/atoms/Typography"
import { scrollToRef } from "../../../../../ui/utilities/scrolling"
import { EditorialLabel } from "../../../../contents"
import { formatItaDate, formatTime } from "../../../utils/format"

interface Props {
  calendar: CalendarEventDataFragment
  data: EventRegistration
}

const EventCalendarTyp = ({ calendar, data }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null)
  React.useEffect(() => scrollToRef(ref, -88), [])

  return (
    <div className="pb-16" ref={ref}>
      <EditorialLabel variant="subtitle1" scope="calendar" id="typ-title" />
      <div className="mt-10">
        <Typography variant="subtitle2" weight="normal">
          Data: {formatItaDate(data.date)}
        </Typography>
      </div>
      <div className="mt-2">
        <Typography variant="subtitle2" weight="normal">
          Orario: {formatTime(data.from)} - {formatTime(data.to)}
        </Typography>
      </div>
      <div className="mt-2">
        <Typography variant="subtitle2" weight="normal">
          {calendar.definition.locationName}
        </Typography>
      </div>
      <EditorialLabel
        variant="body1"
        scope="calendar"
        id="typ-message"
        className="mt-10"
      />
    </div>
  )
}

export default EventCalendarTyp
